// firebaseConfig.ts
declare const config: string; // This makes TypeScript recognize `config` from the JS file

export const getDecodedFirebaseConfig = () => {
  try {
    return JSON.parse(atob(config)); // Decode the Base64 string and parse it as JSON
  } catch (error) {
    console.error('Failed to parse Firebase config:', error);
    return null;
  }
};
